<template>
    <p class="rodape" v-if="dChamado.posicao == 'AB' && semTexto === false">
        Tempo de espera: {{ state.formatado }}
    </p>
    <p class="rodape" v-else-if="dChamado.posicao == 'AD' && semTexto === false">
        Tempo Gasto: 0
    </p>
    <p class="rodape" v-else-if="((dChamado.posicao != 'AB' && dChamado.posicao != 'AD') && semTexto === false)">
        Tempo Gasto: {{ state.formatado }}
    </p>
    <p class="rodape" v-else-if="semTexto === true">
        {{ state.formatado }}
    </p>
</template>

<script setup>
import store from '@/store/store';
import { reactive, onMounted, computed, defineProps } from 'vue';

const props = defineProps(['dChamado', 'semTexto']);

const state = reactive({
    formatado: 0
});
onMounted(() => {
    calcularTempoEspera();
});

function calcularTempoEspera() {
    if (config.value.cronometro && props.dChamado.posicao == "AB") {
        setInterval(() => {
            let dataDoServidor = new Date(props.dChamado.data.split("T")[0] + "T" + props.dChamado.hora);
            let dataAtual = new Date();
            let diferenca = new Date(dataAtual - dataDoServidor);
            state.formatado = converterHora(diferenca);
        }, 1000);
    } else if (config.value.cronometro && props.dChamado.posicao != "AB") {
        let dataDoServidor = new Date(props.dChamado.data.split("T")[0] + "T" + props.dChamado.hora);
        if (props.dChamado.dtFinalizacao != null) {
            let dataFinalizacao = new Date(props.dChamado.dtFinalizacao.split("T")[0] + "T" + props.dChamado.hrFinalizacao);
            let diferenca = new Date(dataFinalizacao - dataDoServidor);
            state.formatado = converterHora(diferenca);
        } else if (props.dChamado.dtCancelamento != null) {
            let dataCancelamento = new Date(props.dChamado.dtCancelamento.split("T")[0] + "T" + props.dChamado.hrCancelamento);
            let diferenca = new Date(dataCancelamento - dataDoServidor);
            state.formatado = converterHora(diferenca);
        }
    }
}

function converterHora(diferenca) {
    let resultado = "";
    if (diferenca.getUTCDate() - 1) {
        resultado += diferenca.getUTCDate() - 1 + "d ";
    }
    if (diferenca.getUTCHours()) {
        resultado += diferenca.getUTCHours() + "h ";
    }
    if (diferenca.getUTCMinutes()) {
        if (diferenca.getUTCMinutes() > 9) {
            resultado += diferenca.getUTCMinutes() + "m ";
        } else {
            resultado += "0" + diferenca.getUTCMinutes() + "m ";
        }
    }
    if (diferenca.getUTCSeconds()) {
        if (diferenca.getUTCSeconds() > 9) {
            resultado += diferenca.getUTCSeconds() + "s ";
        } else {
            resultado += "0" + diferenca.getUTCSeconds() + "s ";
        }
    }
    return resultado;
}

const config = computed(() => {
    return store.state.config;
});
</script>

<style scoped>
.rodape {
    margin: 0;
    font-size: 0.9rem;
    text-transform: none;
    font-weight: lighter;
}

.urgencia-card .rodape {
    color: #FFF;
}
</style>